import { useState, useEffect } from 'react';

export function usePWA() {
  const [isInstalled, setIsInstalled] = useState(false);
  const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
  const [updateServiceWorker, setUpdateServiceWorker] = useState<(() => void) | null>(null);

  useEffect(() => {
    // Register service worker manually
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('SW Registered: ', registration);
          
          // Check for updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  setIsUpdateAvailable(true);
                  setUpdateServiceWorker(() => () => {
                    newWorker.postMessage({ type: 'SKIP_WAITING' });
                    window.location.reload();
                  });
                }
              });
            }
          });
        })
        .catch((error) => {
          console.log('SW registration error', error);
        });
    }
  }, []);

  useEffect(() => {
    // Check if app is installed (running in standalone mode)
    const checkInstallation = () => {
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      const isWebApp = (window.navigator as any).standalone === true;
      setIsInstalled(isStandalone || isWebApp);
    };

    checkInstallation();
    
    // Listen for display mode changes
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    mediaQuery.addEventListener('change', checkInstallation);

    // Listen for app installed event
    window.addEventListener('appinstalled', () => {
      setIsInstalled(true);
    });

    return () => {
      mediaQuery.removeEventListener('change', checkInstallation);
    };
  }, []);

  const updateApp = () => {
    if (updateServiceWorker) {
      updateServiceWorker();
    }
  };

  const dismissUpdate = () => {
    setIsUpdateAvailable(false);
  };

  return {
    isInstalled,
    isUpdateAvailable,
    updateApp,
    dismissUpdate,
  };
}